import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import { on } from "@ember/modifier";
import { fn } from "@ember/helper";
import { or } from "ember-truth-helpers";
import { not } from "ember-truth-helpers";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import TaskForm from "glesys-controlpanel/components/task-form";
import Label from "glesys-controlpanel/components/label";
import GButton from "glesys-controlpanel/components/g-button";
import SelectableServerItem from "glesys-controlpanel/components/selectable-server-item";

export default class ModalsBlockStorageAttach extends Component {
  @service modal;
  @service router;

  @tracked serverid = null;

  get task() {
    return this.args.params.task;
  }

  get kvmServers() {
    return this.args.params.servers.filter((server) => server.supportsBlockStorage);
  }

  get accessList() {
    return this.serverid ? [this.serverid] : [];
  }

  submitTask = task(async () => {
    await this.task.perform(this.serverid);

    this.modal.close();
  });

  goToServerRoute = () => {
    this.modal.close();
    this.router.transitionTo("servers.create.virtual");
  };

  toggleServer = (server) => {
    let id = server.get("id");

    this.serverid = this.serverid === id ? null : id;
  };

  <template>
    <Header>
      {{t "block-storage-volumes.details.modal.attachment"}}
    </Header>
    <Body>
      <TaskForm id="attach" data-test-input-field-for-volume-serverid @task={{this.submitTask}}>
        <div class="min-h-32 max-h-128 overflow-auto">
          {{#if this.kvmServers}}
            <Label>
              {{t "block-storage-volumes.details.modal.attachment-server-label"}}
            </Label>
            {{#each this.kvmServers as |server|}}
              <SelectableServerItem
                @server={{server}}
                @accessList={{this.accessList}}
                @onToggle={{fn this.toggleServer server}}
              />
            {{/each}}
          {{else}}
            <div class="mb-2" data-test-block-storage-volumes-update-attachment-modal-has-no-server>
              {{t "block-storage-volumes.details.modal.attachment-no-servers"}}
            </div>
            <GButton
              data-test-transition-to-create-server
              @type="button"
              @color="blue"
              {{on "click" this.goToServerRoute}}
            >
              {{t "button.create-server"}}
            </GButton>
          {{/if}}
        </div>
      </TaskForm>
    </Body>
    <Footer>
      <GButton class="mr-2" @type="button" @color="gray" {{on "click" (modalClose)}}>
        {{t "button.close"}}
      </GButton>
      <GButton
        data-test-block-storage-attach-submit
        @type="submit"
        @color="blue"
        @disabled={{or this.task.isRunning (not this.serverid)}}
        form="attach"
      >
        {{t "button.attach"}}
      </GButton>
    </Footer>
  </template>
}
